export const DataHooks = {
    title: 'title',
    subtitle: 'subtitle',
    suffix: 'suffix',
};
//# sourceMappingURL=hooks.js.map